import { Button, Box, Text, useTokens, Heading, Grid } from '@mezzoforte/forge';
import { useQueryClient } from '@tanstack/react-query';
import { formatCurrency } from '@/util/currency';
import { useApi } from '@/hooks/useApi';

const { colors } = useTokens.huutokaupat;

interface AutobidActiveProps {
  entryId: number;
  minimumRaise: number;
  maxBid: number;
}

export function AutobidActive({ entryId, minimumRaise, maxBid }: AutobidActiveProps) {
  const queryClient = useQueryClient();
  const { apiClient } = useApi();

  const deactivateAutobid = () =>
    apiClient
      .post('/api/net-auction-bid/autobiddeactivate', { id: entryId })
      .then(() => {
        void queryClient.invalidateQueries({ queryKey: ['currentUser', 'entries', entryId] });
      })
      .catch(() => console.error('Jotain meni pieleen! Korotusautomaatin poistaminen epäonnistui.'));

  return (
    <Box
      sx={{
        padding: 4,
        backgroundColor: colors.backgroundGray,
      }}
      data-test="autbid-active"
    >
      <Heading
        variant="h4"
        as="h4"
      >
        Sinulla on korotusautomaatti käytössä
      </Heading>
      <Grid
        templateColumns="1fr 1fr"
        gap={1}
        mt={3}
      >
        <Text>Maksimitarjous:</Text>
        <Text>Automaattinen korotus:</Text>
        <Text
          data-test="autbid-max"
          variant="bold"
        >
          {formatCurrency(maxBid)}
        </Text>
        <Text
          data-test="autobid-amount"
          variant="bold"
        >
          {formatCurrency(minimumRaise)}
        </Text>
      </Grid>
      <Button
        w="100%"
        mt={3}
        onClick={deactivateAutobid}
      >
        Poista korotusautomaatti
      </Button>
    </Box>
  );
}
